import React, { Component } from 'react'
import { Header, PageWrapper, ImageCapture, PageLoader, Toast } from '../components'
import { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo'
import styled from 'styled-components'
import Cookies from 'js-cookie'
import axios from 'axios'
import { API_URL } from '../constants'

const ScannerWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`
class ScanReceipt extends Component {
  state = {
    result: {},
    dataUri: {},
    isUpLoading: false,
    openToast: false
  }
  componentDidMount() {}
  async onTakePhoto(dataUri) {
    // Do stuff with the dataUri photo...
    const blob = this.dataURItoBlob(dataUri)
    const dat = new FormData()
    dat.append('file', blob)
    const { data } = await axios.post(`${API_URL}/Containers/gcapp/upload`, dat)
    await this.setState({ dataUri: data })
    this.uploadPhoto()
  }
  uploadPhoto = async () => {
    this.setState({ isUpLoading: true })
    try {
      const { data: result } = await axios.post(`${API_URL}/UserReceipts`, {
        image: this.state.dataUri.result.files.file[0].name,
        userId: Cookies.get('user_id')
      })
      this.setState({ result, isUpLoading: false })
    } catch (error) {
      this.setState({ isUpLoading: false })
    }
  }
  dataURItoBlob(dataURI) {
    var binary = atob(dataURI.split(',')[1])
    var array = []
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i))
    }
    return new Blob([new Uint8Array(array)], { type: 'image/jpeg' })
  }
  handleClose = async (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    await this.setState({ openToast: false })
    this.props.history.goBack()
  }
  render() {
    const { isUpLoading, openToast } = this.state
    return (
      <React.Fragment>
        <Header title="Scan Receipt" icon={'arrowBack'} onClickBack={() => this.props.history.goBack()} color="#fff" />
        {isUpLoading ? (
          <PageLoader />
        ) : (
          <PageWrapper viewPadding="76px 16px 20px">
            <ScannerWrapper>
              <ImageCapture
                idealResolution={{ width: 400, height: 850 }}
                onCameraError={error => {
                  this.onCameraError(error)
                }}
                idealFacingMode={FACING_MODES.ENVIRONMENT}
                imageType={IMAGE_TYPES.JPG}
                imageCompression={0.97}
                isMaxResolution={false}
                isImageMirror={false}
                isDisplayStartCameraError={true}
                sizeFactor={1}
                onTakePhoto={dataUri => {
                  this.onTakePhoto(dataUri)
                }}
              />
            </ScannerWrapper>
          </PageWrapper>
        )}
        <Toast open={openToast} message="Receipt scanned successfully" onClose={this.handleClose} />
      </React.Fragment>
    )
  }
}

export default ScanReceipt



// WEBPACK FOOTER //
// ./src/pages/ScanReceipt.js